import styled from "styled-components";

const TOUCH_TARGET_SIZE = 44;

// Icon-only control: a real <button> (focusable, announced by screen readers)
// with a 44x44 touch target around a small icon. Always pass an aria-label.
// The negative margin keeps the surrounding layout the same as a bare icon.
const StyledIconButton = styled.button(() => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  minWidth: TOUCH_TARGET_SIZE,
  minHeight: TOUCH_TARGET_SIZE,
  padding: 0,
  border: "none",
  background: "transparent",
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",

  img: {
    display: "block",
  },
}));

const IconButton = ({ src, label, iconSize = 20, iconStyle, style, ...props }) => (
  <StyledIconButton
    type="button"
    aria-label={label}
    style={{ margin: -(TOUCH_TARGET_SIZE - iconSize) / 2, ...style }}
    {...props}
  >
    <img src={src} alt="" style={{ width: iconSize, height: iconSize, ...iconStyle }} />
  </StyledIconButton>
);

export default IconButton;
